import { dictionaryApi } from "api/dictionary.api";
import { useRef, useState } from "react";
import { Dictionary } from "types/dictionary";
import { QueryParam } from "types/query";

export interface DictionaryQuery extends QueryParam {}

interface UseDictionaryProps {
  initQuery: DictionaryQuery;
}

export const useDictionary = ({ initQuery }: UseDictionaryProps) => {
  const [data, setData] = useState<Dictionary[]>([]);
  const [total, setTotal] = useState(0);
  // const [query, setQuery] = useState<DictionaryQuery>(initQuery);
  const query = useRef<DictionaryQuery>(initQuery);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await dictionaryApi.findAll(query.current);

      setData(data.dictionaries);
      setTotal(data.total);
    } finally {
      setLoading(false);
    }
  };

  return {
    dictionaries: data,
    total,
    fetchData,
    loading,
    query: query.current,
  };
};
